<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Error</title>
</head>
<body>
<div class="container">
  <h1>{{ heading }}</h1>
  <p>{{ message }}</p>
  <button type="button" class="btn" (click)="onLoginClick()">Log In</button>
</div>
</body>
</html>